jQuery(document).ready(function($) {

  if ($('.page-template-template-team').length < 1) return;

  var sizeGrids = function() {
    //check for mobile
    if ($('.masonry').css('display') == 'block') {
      $('.masonry').css('height', 'auto');
      return;
    }

    var width = $('.team > .l-row__container > .l-column > .l-squeeze').width();
    //Size non-intro grids first 690 + 88px padding at 1035 width
    var height = .666666666666667 * width + 88;
    $('.masonry').css('height', height + 'px');
    
    //Size intro 804 + 44px padding at 1035 width
    height = .776811594202899 * width + 44;
    $('.masonry--intro').css('height', height + 'px');
  };

  $('#filter').on('change', function() {
    var val = $(this).val();

    if (val != '') {
      window.location.href = val;
    }
  });

  sizeGrids();
  $(window).on('resize', sizeGrids);

}, jQuery);
